@if (authService.hasPermission(Permission.ShootAssetsRead)) {
  <app-products-recent-section
    title="Recently Shot"
    [products]="recentlyShotList"
    filter="RecentlyShot"
    (viewMore)="viewMore($event)"
  ></app-products-recent-section>
}
